import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client';

import { customScalarLink } from '@/lib/apollo/links/customScalar';
import { httpLink } from '@/lib/apollo/links/http';

import { createAuthLink } from '../links/auth';

export const createApolloClient = () => {
  const authLink = createAuthLink();
  const cache = new InMemoryCache({
    typePolicies: {
      // User オブジェクトの識別キーを userId に指定
      User: {
        keyFields: ['userId'],
      },
      // Wallet オブジェクトは単体 ID を持たないためキー化を無効化
      Wallet: {
        keyFields: ['balance'],
      },
    },
  });

  return new ApolloClient({
    link: ApolloLink.from([authLink, customScalarLink, httpLink]),
    cache: cache,
    devtools: {
      enabled: import.meta.env.VITE_ENABLE_APOLLO_TOOLS === '1',
    },
    // notifyOnNetworkStatusChangeは既定（true）のままにする。falseにすると、useLazyQueryの実行中も
    // loadingがtrueにならず、loadingを見て次の処理を判断する箇所（無限スクロール・検索結果の表示等）が
    // 先に進んでしまう。ポーリングの再取得でloadingを切り替えたくないクエリは、各クエリで個別にfalseを指定する
  });
};
